export default {
  validation: {
    error: {
      generic: 'There are validation errors on the current form',
    },
    success: {
      generic: 'There was success contact Dom',
    },
  },
  reviews: {
    delete: {
      success: 'You have successfully deleted the review',
      error: 'There was an error deleting the review',
    },
    create: {
      success: 'You have successfully created the review',
      error: 'There was an error creating the review',
    },
    updateJobDetails: {
      success: 'You have successfully updated job details for the review',
      error: 'There was an error updating the job details the review',
    },
    updateAnswer: {
      success: 'You have successfully updated the answer for this review',
      error: 'There was an error updating the answer for this review',
    },
    moderation: {
      success: 'You have successfully put the review live',
      error: 'There was an error putting the review live',
    },
    // unmoderate: {
    //   success: 'You have successfully put the review back into moderation',
    //   error: 'There was an error putting the review back into moderation',
    // },
    /*
    incentiveCriteria: {
      hint: (answerCount) => `Please provide at least ${answerCount} answers with 50 words each in order to qualify for a £5 Amazon voucher`,
    },
    changeVoucherEligibility: {
      success: 'You have successfully changed the incentive eligibility',
      error: 'There was an error changing the incentive eligibility',
    },
    */
    changeExcludedFromTableStatus: {
      success: 'You have successfully changed the exclusion from TEG status',
      error: 'There was an error changing the exclusion from TEG status',
    },
    changeSpamStatus: {
      success: 'You have successfully changed the spam status',
      error: 'There was an error changing the spam status',
    },
    sendIncentiveEmail: {
      success: 'You have successfully sent the incentive email',
      error: 'There was an error sending the incentive email',
    },
    salaryHelp: {
      1: {
        label: 'Enter Annual Salary',
        frequency: 'year',
        hint: 'Annual pay is the total pay for the year.',
        validation: {
          min: 4000,
          max: 100000,
        },
      },
      2: {
        label: 'Enter Monthly Salary',
        frequency: 'month',
        hint: 'Monthly pay is the amount you get paid every calendar month.',
        validation: {
          min: 400,
          max: 2000,
        },
      },
      3: {
        label: 'Enter Weekly Salary',
        frequency: 'week',
        hint: 'How much you get paid each week.',
        validation: {
          min: 100,
          max: 800,
        },
      },
      4: {
        label: 'Enter Hourly Salary',
        frequency: 'hour',
        hint: 'This is how much your employer pays you based on each hour you work. The hourly UK minimum wage is £4.15 if you are under 19 and £6.45 if you are aged 19 or over.',
        validation: {
          min: 3,
          max: 20,
        },
      },
    },
    voucherEligibility: {
      success: {
        header: 'You\'re all set',
        copy: `Click the button below to go to the overview stage where you will get a final chance
               to check your review before submitting it for moderation.`,
        buttonText: 'Yes! Submit Review',
      },
      error: {
        header: 'You do not qualify for a £5 Amazon voucher!',
        copy: (wordCountWarnings) => `You have provided less than the recommended 50 words for at least <strong>${wordCountWarnings}</strong> of your answers.
        You can continue and submit the review for moderation but you will not qualify for a £5 Amazon voucher. Please see <a href='/terms-and-conditions'>terms & conditions</a> for more information.`,
        buttonText: 'Continue',
      },
    },
    reviewOverview: {
      header: 'Please confirm your review',
      copy: `By hitting the “Submit Review” button below your review will be submitted to a member of our team who will aim to moderate your review in 3 working days.
      Once moderated you will receive an email saying your review is live.`,
      checkbox: 'I confirm all details above are correct and that all views within the review are my own.',
      buttonText: 'Submit Review',
    },
    submitToModeration: {
      success: 'You have successfully submitted your review to our moderation team',
      error: 'There was an error submitting your review to our moderation team',
    },
    reviewComplete: {
      copy: `
        <p>Your review has now been submitted. Once it’s live, we’ll plant a tree for you!</p>
        <h3>What's next?</h3>
        <p>Your review will get checked over by our team to ensure it meets our <a href='/blog/terms-conditions/'>terms & conditions</a> - this should take about 3 working days. We’ll let you know once it goes live.</p>
        <p>We now <strong>plant a tree</strong> for every review left on our website, so you’re not just helping out your peers, but the environment too. Nice one! 🌲</p>
      `,
      optIn: {
        copy: 'Would you like to receive emails from RateMyApprenticeship?',
      },
      ukBased: {
        copy: 'Are you based in the UK?',
      },
      gender: {
        copy: 'What is your gender?',
      },
      institutionStartYear: {
        copy: 'Secondary school start year?',
      },
      jobRoles: {
        copy: 'Industries interested in?',
      },
      postCode: {
        copy: 'Postcode?',
      },
      buttonText: 'Update my preferences',
    },
    voucherUpload: {
      success: 'Review vouchers were uploaded successfully',
      error: 'There was an issue uploading the review vouchers',
      incorrectFileType: 'Only .csv files are allowed. Please check the file format and encoding',
    },
  },
  generic: {
    success: 'Your action was successful',
    error: 'There was an error performing your action',
  },
  user: {
    delete: {
      success: 'You have successfully deleted the user',
      error: 'There was an error deleting the user',
    },
    login: {
      success: 'You have successfully logged in',
      error: 'There was an error logging in',
    },
    register: {
      success: 'You have successfully created an account',
      error: 'There was an error creating your account',
    },
    updateOptIn: {
      success: 'Email preferences updated successfully',
      error: 'There was an error updating your email preferences',
    },
    updateUser: {
      success: 'User details updated successfully',
      error: 'There was an error updating your user details',
    },
    auth: {
      sessionExpired: 'Your session has expired, please login again.',
    },
  },
  unknownLocation: {
    delete: {
      success: 'You have successfully deleted the unknown location',
      error: 'There was an error deleting the unknown location',
    },
  },
};
